import netLogo from '@/assets/img/home/logos/123NEtLogo.svg';
import allPointsBroadbandLogo from '@/assets/img/home/logos/allPointsBroadbandLogo.svg';
import archtopLogo from '@/assets/img/home/logos/archtopLogo.svg';
import astoundLogo from '@/assets/img/home/logos/astoundLogo.svg';
import blueRidgeLogo from '@/assets/img/home/logos/blueRidgeLogo.svg';
import breezeline from '@/assets/img/home/logos/breezeline.svg';
import dfnLogo from '@/assets/img/home/logos/dfnLogo.svg';
import elauwitLogo from '@/assets/img/home/logos/elauwitLogo.svg';
import empireAccessLogo from '@/assets/img/home/logos/empireAccessLogo.svg';
import ezeeFiberLogo from '@/assets/img/home/logos/ezeeFiberLogo.svg';
import fastwyreBroadLogo from '@/assets/img/home/logos/fastwyreBroadLogo.svg';
import fiberFastHomesLogo from '@/assets/img/home/logos/fiberFastHomesLogo.svg';
import foothillsConnectionsLogo from '@/assets/img/home/logos/foothillsConnectionsLogo.svg';
import forgedFiber37Logo from '@/assets/img/home/logos/forgedFiber37Logo.svg';
import gloFiberLogo from '@/assets/img/home/logos/gloFiberLogo.svg';
import gonetSpeedLogo from '@/assets/img/home/logos/GonetspeedLogo.webp';
import greenlightNetworksLogo from '@/assets/img/home/logos/GreenlightNetworksLogo.webp';
import lightcurveLogo from '@/assets/img/home/logos/lightcurveLogo.svg';
import loopInternetLogo from '@/assets/img/home/logos/LoopInternetLogo.webp';
import lumenLogo from '@/assets/img/home/logos/lumenLogo.svg';
import mainstreamFiberLogo from '@/assets/img/home/logos/mainstreamFiberLogo.svg';
import metronetLogo from '@/assets/img/home/logos/metronetLogo.svg';
import midwestEnergyLogo from '@/assets/img/home/logos/midwestEnergyLogo.svg';
import omniFiberLogo from '@/assets/img/home/logos/omniFiberLogo.svg';
import pavlovMediaLogo from '@/assets/img/home/logos/pavlovMediaLogo.svg';
import pointBroadbandLogo from '@/assets/img/home/logos/pointBroadbandLogo.svg';
import rippleFiberLogo from '@/assets/img/home/logos/rippleFiberLogo.svg';
import serviceElectricLogo from '@/assets/img/home/logos/serviceElectricLogo.svg';
import shentelLogo from '@/assets/img/home/logos/shentelLogo.svg';
import skywireLogo from '@/assets/img/home/logos/skywireLogo.svg';
import slicFiberLogo from '@/assets/img/home/logos/slicFiberLogo.svg';
import smartairaLogo from '@/assets/img/home/logos/smartairaLogo.svg';
import sparklightLogo from '@/assets/img/home/logos/sparklightLogo.svg';
import spectrumLogo from '@/assets/img/home/logos/spectrumLogo.svg';
import tillmanFiberLogo from '@/assets/img/home/logos/tillmanFiberLogo.svg';
import u1groupLogo from '@/assets/img/home/logos/u1groupLogo.svg';
import weLinkLogo from '@/assets/img/home/logos/weLinkLogo.svg';
import wire3Logo from '@/assets/img/home/logos/wire3Logo.svg';

const logos = [
  u1groupLogo,
  skywireLogo,
  gloFiberLogo,
  pointBroadbandLogo,
  serviceElectricLogo,
  omniFiberLogo,
  shentelLogo,
  breezeline,
  archtopLogo,
  elauwitLogo,
  ezeeFiberLogo,
  fastwyreBroadLogo,
  fiberFastHomesLogo,
  weLinkLogo,
  tillmanFiberLogo,
  spectrumLogo,
  sparklightLogo,
  smartairaLogo,
  rippleFiberLogo,
  foothillsConnectionsLogo,
  dfnLogo,
  lightcurveLogo,
  lumenLogo,
  wire3Logo,
  netLogo,
  gonetSpeedLogo,
  greenlightNetworksLogo,
  loopInternetLogo,
  blueRidgeLogo,
  allPointsBroadbandLogo,
  empireAccessLogo,
  pavlovMediaLogo,
  astoundLogo,
  slicFiberLogo,
  mainstreamFiberLogo,
  metronetLogo,
  forgedFiber37Logo,
  midwestEnergyLogo,
];

const half = Math.ceil(logos.length / 2);

const firstRowLogos = logos.slice(0, half);
const secondRowLogos = logos.slice(half);

const LogoRow = ({ direction, logos }: { direction: 'left' | 'right'; logos: typeof firstRowLogos }) => {
  const animation =
    direction === 'left'
      ? 'animate-marquee-left md:animate-marquee-left-md'
      : 'animate-marquee-right md:animate-marquee-right-md';

  return (
    <div className="w-full overflow-hidden">
      <div className={`flex w-[200%] ${animation}`}>
        {[...logos, ...logos, ...logos].map((logo, index) => (
          <div key={index} className="flex min-w-[200px] items-center justify-center px-10">
            <img src={logo} alt="Logo" width={140} height={48} className="h-[48px] w-[140px] object-scale-down" />
          </div>
        ))}
      </div>
    </div>
  );
};

/**
 * "Trusted by Industry Leaders" logo marquee — faithful port of the legacy
 * reipm `components/home/TrustedByIndustryLeadersBlock.tsx`. The two rows
 * scroll in opposite directions; keyframes/animations live in `globals.css`
 * (ported from the legacy tailwind.config). The heading keeps the legacy
 * `gpm-blue-dark` gradient as an arbitrary value.
 * (The legacy `md:py-26` never resolved to a real Tailwind v3 utility, so the
 * rendered padding was `py-20` — reproduced as such.)
 */
export default function TrustedByIndustryLeadersBlock() {
  return (
    <section className="space-y-8 bg-white py-20">
      <h2 className="mb-6 bg-[linear-gradient(180deg,#0061E5,#00429C)] bg-clip-text text-center text-[32px] leading-[32px] font-bold text-transparent">
        Trusted by Industry Leaders
      </h2>
      <LogoRow direction="right" logos={firstRowLogos} />
      <LogoRow direction="left" logos={secondRowLogos} />
    </section>
  );
}
